export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-white">
      <div className="mx-auto max-w-6xl px-6 py-10 text-sm text-slate-500">
        <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
          <span>© {new Date().getFullYear()} Cardin Company SAC.</span>
          <span>Ventas y cotizaciones por WhatsApp.</span>
        </div>
      </div>
    </footer>
  );
}
